import request from '@/utils/request'
import get from 'lodash/get'
import { App } from '@/types'
import jsonp from 'jsonp'
import store from '@/store'

const apiFactory = () => {
  const getStoreRating = (appId: string): Promise<App.StoreRating | null> => {
    return new Promise((resolve, reject) => {
      jsonp(`https://itunes.apple.com/lookup?id=${appId}`, (err, data) => {
        if (err) {
          reject(err)
        }
        resolve(data)
      })
    })
      .then(data => get(data, 'results.0'))
      .then(
        ({
          averageUserRating: score,
          userRatingCount: count
        }) => ({ score, count }))
      .catch(() => null)
  }
  const testNetworkConnection = () => {
    const baseURL = store.getters['app/baseURL']
    const serviceForTest = '/cadence-service/health'
    return fetch(`${baseURL}${serviceForTest}`)
  }
  const testBranchAvailability = () => {
    return request({
      url: 'https://app.link/_r',
      method: 'get'
    })
      .then(() => true)
      .catch(() => false)
  }

  return { testBranchAvailability, getStoreRating, testNetworkConnection }
}

export default apiFactory
